export default __webpack_public_path__ + "static/au-573f1dde246a3431ebf6a31bb8b7c918.jpg";